<template>
  <div>
    <div>
      <validation-observer ref="amendmentForm">
        <div class="row py-4 px-5">
          <div class="col-12">
            <label class="font-18 font-weight-bold">
              <i class="fas fa-comment text-orange mr-1" />
              Enmendar
            </label>
          </div>
          <div class="col-12">
            <validation-provider v-slot="{ errors }" rules="required">
              <custom-text-area
                v-model="model.comment"
                custom-error-msg="El comentario es requerido."
                :error="errors[0]"
                label="Comentario:"
                :maxlength="3000"
                show-char-count
              />
            </validation-provider>
          </div>
          <div class="col-12 d-flex justify-content-end align-items-center">
            <action-button
              i="fas fa-times-circle"
              text="Cancelar"
              variant="outline-danger mr-3 px-3"
              @click="cancel"
            />
            <action-button
              i="fas fa-save"
              text="Guardar"
              variant="success px-3"
              @click="save"
            />
          </div>
        </div>
      </validation-observer>
    </div>
  </div>
</template>
<script>
import CustomTextArea from 'CustomTextArea';

export default {
  name: 'AmendmentComment',
  components: {
    CustomTextArea,
  },
  data: () => ({
    model: {
      comment: null,
    },
  }),
  methods: {
    async save() {
      const isValid = await this.$refs.amendmentForm.validate();
      if (!isValid) return;
      this.$emit('save', this.model.comment);
      this.$refs.amendmentForm.reset();
    },
    async cancel() {
      this.model.comment = null;
      this.$emit('cancel');
    },
  },
};
</script>
<style lang=""></style>
